import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Lodderr from "../Lodder/Lodder";
import { GetTransaction } from "../../apis/api/NMMBusinessApi";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import CommentModal from "../../Models/Buisnes_Impact/CommentModal";
import { motion } from "framer-motion";
import "./BusinessImpact.css";

/** API may send amount as number, string, or formatted string ("$1,234.50") */
function parseAmount(value) {
  if (value == null || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const cleaned = String(value).replace(/[$,\s]/g, "").replace(/^\++/, "");
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
}

const MemberTable = () => {
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const { TransactionGet, loading } = useSelector((state) => state.NmmBuisness);

  useEffect(() => {
    const companyId = Cookies.get("company_id");
    if (companyId) {
      dispatch(GetTransaction({ id: companyId }));
    }
  }, [dispatch]);

  useEffect(() => {
    const raw = TransactionGet;
    let rows = [];
    if (Array.isArray(raw?.data)) rows = raw.data;
    else if (Array.isArray(raw?.data?.data)) rows = raw.data.data;
    else if (Array.isArray(raw)) rows = raw;
    setTableData(rows);
  }, [TransactionGet]);

  const handleViewClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const rows = Array.isArray(tableData) ? tableData : [];
  const totals = rows.reduce(
    (acc, row) => {
      if (!row || typeof row !== "object") return acc;
      const amount = parseAmount(row.amount);
      acc.volume += amount;
      const t = String(row.transaction_type || "").toLowerCase();
      if (t === "received") acc.received += amount;
      else acc.sent += amount;
      return acc;
    },
    { volume: 0, received: 0, sent: 0 }
  );

  return (
    <>
      {loading && <Lodderr />}
      <motion.div
        className="bi-wrap"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
      <div className="bi-banner">
          <div>
            <h1 className="bi-banner-title">Business Impact</h1>
            <p className="bi-banner-sub">Track your member-to-member transactions in one premium view.</p>
          </div>
          <div className="bi-banner-stats">
            <div className="bi-banner-stat">
              <span>Total Volume</span>
              <strong>${Number.isFinite(totals.volume) ? totals.volume.toLocaleString() : "0"}</strong>
            </div>
            <div className="bi-banner-stat">
              <span>Received</span>
              <strong className="bi-plus">${Number.isFinite(totals.received) ? totals.received.toLocaleString() : "0"}</strong>
            </div>
            <div className="bi-banner-stat">
              <span>Sent</span>
              <strong className="bi-minus">${Number.isFinite(totals.sent) ? totals.sent.toLocaleString() : "0"}</strong>
            </div>
          </div>
        </div>

      <CustomTableWrapper
        title="Transaction Ledger"
        data={rows}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={["sender_company_name", "receiver_company_name", "status", "amount"]}
        columns={[
          { label: "S.No", field: "sno" },
          { label: "Sender Name", field: "sender_company_name", sortable: true },
          { label: "Receiver Name", field: "receiver_company_name", sortable: true },
          { label: "Amount", field: "amount", sortable: true },
          { label: "Status", field: "status" },
          { label: "Date", field: "created_at", sortable: true },
          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index, currentPage, itemsPerPage) => (
          <tr key={index}>
            <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
            <td>{item.sender_company_name}</td>
            <td>{item.receiver_company_name}</td>
            <td className={item.transaction_type === "received" ? "bi-plus" : "bi-minus"}>
              {item.transaction_type === "received" ? `+ ${item.amount}` : `- ${item.amount}`}
            </td>

            <td>
              <span className="bi-status">{item.status}</span>
            </td>
            <td>{item.created_at ? new Date(item.created_at * 1000).toLocaleString() : "-"}</td>
            <td>
              <button
                type="button"
                className="rm-view-btn"
                onClick={() => handleViewClick(item)}
                title="View Comments"
              >
                <i className="bx bx-show"></i> View
              </button>
            </td>
          </tr>
        )}
      />
      </motion.div>

      {/* ✅ Comment Modal */}
      <CommentModal
        show={showModal}
        handleClose={handleClose}
        selectedItem={selectedItem}
      />
    </>
  );
};

export default MemberTable;
